var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEligibilityDashedLine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 120,
    viewBox: "0 0 1440 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1811_21907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1625.73 107.51C1599.55 90.7244 1534.21 53.3555 1472.11 53.8551C1392.1 54.5545 1341.97 85.4288 1286.28 88.3264C1252.22 90.1249 1262.52 92.5229 1209.7 88.4263C1152.06 83.9301 1139.34 84.3297 1113.54 66.045C1092.19 50.8576 1097.2 18.5845 1108.81 9.49209C1120.41 0.299751 1136.19 -1.7985 1147.79 5.49542C1164.96 16.1865 1166.91 33.4721 1167.1 48.06C1167.19 57.652 1163.57 81.632 1148.26 90.5246C1135.54 98.0183 1127.74 97.8185 1114.1 97.7186C1090.43 97.4188 1020.53 64.9459 987.675 56.453C954.816 47.96 929.755 45.0625 903.301 46.761C863.48 49.3589 824.124 60.3497 779.941 77.1357C735.759 93.9217 660.759 99.4172 622.146 98.418C562.74 96.9192 465.092 67.7436 390.65 50.9575C316.95 34.3714 236.196 39.4671 165.93 52.756C95.1077 66.1449 38.3012 85.1291 -14.514 93.2223C-61.203 100.316 -106.314 103.114 -132.582 103.913",
    stroke: "#CCEDEC",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "10.04 10.04"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1811_21907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1783,
    height: 120,
    fill: "white",
    transform: "matrix(-1 0 0 1 1639 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEligibilityDashedLine);
export default __webpack_public_path__ + "static/media/eligibility-dashed-line.1e6418b890bcad51b24984f66980d420.svg";
export { ForwardRef as ReactComponent };